import * as A from "~/parse/sfml-ast";

export class Helper {
  public static getWayfinderItemIds(storefront: A.StorefrontElement): { [key: string]: A.ItemElementBase[] } {
    const wayfinderItemIds: { [key: string]: A.ItemElementBase[] } = {};
    const wayfinder = storefront.wayfinder;

    if (!wayfinder) return wayfinderItemIds;

    const wayfinderAnchorIds = new Set<string>();
    for (const category of wayfinder.categories) wayfinderAnchorIds.add(category.anchorId);

    let activeAnchorId = null;

    const content: A.UIElementBase[] = [];

    if (A.instanceOfUIElementBase(storefront.content)) content.push(storefront.content);

    for (let i = 0; i < content.length; ++i) {
      const element = content[i];

      if (!A.instanceOfUIElement(element)) continue;

      if (element.anchorId && wayfinderAnchorIds.has(element.anchorId)) {
        activeAnchorId = element.anchorId;

        if (!wayfinderItemIds[activeAnchorId]) {
          wayfinderItemIds[activeAnchorId] = [];
        }
      }

      if (A.instanceOfUIElementContainer(element)) {
        for (const child of element.content) {
          if (A.instanceOfUIElementBase(child)) content.push(child);
        }
      }

      if (A.instanceOfItemAtomElement(element)) {
        if (!activeAnchorId || !wayfinderItemIds[activeAnchorId]) continue;

        wayfinderItemIds[activeAnchorId].push({
          itemType: element.itemType,
          itemId: element.itemId,
          targetAnchorId: element.targetAnchorId,
          payload: element.payload,
        });
      }

      if (A.instanceOfImageElementBase(element)) {
        for (const source of element.sources) {
          if (!A.instanceOfFlyerSourceElement(source)) continue;

          for (const area of source.areas) {
            if (!activeAnchorId || !wayfinderItemIds[activeAnchorId]) continue;

            wayfinderItemIds[activeAnchorId].push({
              itemType: area.itemType,
              itemId: area.itemId,
              targetAnchorId: area.targetAnchorId,
              payload: area.payload,
            });
          }
        }
      }
    }

    return wayfinderItemIds;
  }
}



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/renderer/web-components/wayfinder/sfml-helper.ts